import { ReactComponent as Logo } from '../../images/logo.svg';
import LangDropdown from '../LangDropdown/LangDropdown';
import { useTranslation } from 'react-i18next';
import CTRObserver from '../../wrappers/CTRObserver';
import './Header.scss';
import ProfileDropdown from '../ProfileDropdown/ProfileDropdown';
import { useAppSelector } from '../../hooks';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as SalesIcon } from '../../icons/sales.svg';
import { useBookMeetingModal } from '../../context/bookMeetingModalContext';
import classNames from 'classnames';
import { ReactComponent as BackIcon } from '../../icons/back.svg';
import Button from '../Button';

interface Props {
  blockKey?: string;
  btn?: JSX.Element;
  CTABtnLabel?: string;
  logo?: boolean;
  backBtn?: boolean;
  label?: string;
  backBtnPath?: string;
  className?: string;
}

const Header = ({
  blockKey,
  btn,
  CTABtnLabel = 'Get help',
  logo = true,
  backBtn,
  label,
  backBtnPath,
  className = '',
}: Props) => {
  const { t } = useTranslation();
  const user = useAppSelector((s) => s.user.user);
  const history = useHistory<{
    hasPrevPath?: boolean;
  }>();
  const { openModal } = useBookMeetingModal();

  return (
    <div className={`Header sticky-top border-bottom ${className}`} id='header'>
      <div
        className={classNames('d-flex align-items-center', {
          'justify-content-between': logo || backBtn,
          'justify-content-end': !logo && !backBtn,
        })}
      >
        <div className='d-flex align-items-center'>
          {logo && (
            <Link to='/' tabIndex={-1} className='pt-1'>
              <Logo className='Header__logo' />
            </Link>
          )}
          {backBtn &&
            (!history.location.state?.hasPrevPath ? (
              <Link className='text-decoration-none' to={backBtnPath || '/'}>
                <BackIcon className='me-2' />
                {t('Go to overview')}
              </Link>
            ) : (
              <Button
                styling='naked'
                onClick={() => {
                  history.goBack();
                }}
              >
                <BackIcon className='me-2' />
                {t('Go to overview')}
              </Button>
            ))}
        </div>
        {label && <div className='fw-800'>{label}</div>}
        <div className='d-flex align-items-center'>
          {blockKey ? (
            <CTRObserver blockKey={blockKey}>
              <div>
                <Button
                  styling='outline'
                  className='Header__btn d-sm-block d-none'
                  onClick={openModal}
                  data-testid='calendly-btn'
                >
                  {t(CTABtnLabel)}
                </Button>
                <Button
                  styling='naked'
                  className='d-sm-none'
                  onClick={openModal}
                  data-testid='calendly-btn-mob'
                >
                  <SalesIcon />
                </Button>
              </div>
            </CTRObserver>
          ) : (
            <div className='d-flex align-items-center'>
              {btn}
              <Button
                styling='outline'
                className='py-1 Header__btn d-sm-block d-none'
                onClick={openModal}
                data-testid='calendly-btn'
              >
                {t(CTABtnLabel)}
              </Button>
              <Button
                styling='naked'
                className='d-sm-none'
                onClick={openModal}
                data-testid='calendly-btn-mob'
              >
                <SalesIcon />
              </Button>
            </div>
          )}
          <div className='d-flex align-items-center ms-2'>
            <LangDropdown />
          </div>
          {user ? (
            <ProfileDropdown className='ms-2' />
          ) : (
            history.location.pathname !== '/' && (
              <Link to={'/'} className='ms-2 fw-600'>
                {t('Login')}
              </Link>
            )
          )}
          {process.env.REACT_APP_ENV &&
            process.env.REACT_APP_ENV !== 'prod' && (
              <div className='Header__badge py-2 px-3'>
                {process.env.REACT_APP_ENV}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Header;
